import React from "react";
import { Link } from "react-router-dom";
import ControlRoomTopology from "@/components/marketing/ControlRoomTopology";

/**
 * Read-only embed of the Ping Tree simulator.
 * Designed for iframe embedding in board decks, Notion docs, prospect emails.
 * Has no header/footer, no nav — just the topology + a discreet "powered by" link.
 */
export default function EmbedPingTree() {
  return (
    <div className="min-h-screen bg-white p-4 sm:p-6 flex flex-col">
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-4xl">
          <ControlRoomTopology />
        </div>
      </div>
      <div className="mt-3 flex items-center justify-center">
        <Link
          to="/"
          target="_top"
          className="inline-flex items-center gap-1.5 text-[11px] font-mono text-slate-500 hover:text-[#0055FF] transition-colors"
          data-testid="embed-powered-by"
        >
          <span className="inline-block size-1.5 rounded-full bg-[#0055FF]" />
          Powered by <span className="font-semibold text-slate-700">Connexis</span>
        </Link>
      </div>
    </div>
  );
}
